export default "__VITE_ASSET__D8nW70Sp__"